import React, { Fragment } from 'react';
import { Section } from './ui/Section';
import { ArrowRight, RefreshCw } from 'lucide-react';
export function ProblemSection() {
  return <Section className="bg-brand-light/30" data-id="element-90">
      <div className="max-w-4xl mx-auto" data-id="element-91">
        <h2 className="text-3xl md:text-4xl font-serif text-center mb-8 text-brand-text" data-id="element-92">
          El problema real <br data-id="element-93" />
          <span className="text-brand-primary italic text-2xl md:text-3xl" data-id="element-94">
            (y por qué te sentís así)
          </span>
        </h2>

        <p className="text-center text-lg text-gray-600 mb-12 max-w-2xl mx-auto" data-id="element-95">
          En esta etapa, el cuerpo se vuelve más sensible a cosas que antes
          tolerabas: calor, estrés, poco sueño, cafeína tarde, comidas pesadas.
        </p>

        <div className="relative bg-white p-8 rounded-2xl shadow-sm border border-brand-primary/10" data-id="element-96">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-primary text-white px-4 py-1 rounded-full text-sm font-medium" data-id="element-97">
            El Ciclo Reactivo
          </div>

          <div className="grid md:grid-cols-4 gap-4 items-center" data-id="element-98">
            {[{
            title: 'Dormís peor',
            desc: 'Sueño interrumpido'
          }, {
            title: 'Más reactiva',
            desc: 'Sistema nervioso alerta'
          }, {
            title: 'Más sofocos',
            desc: 'Y bajones de energía'
          }, {
            title: 'Más ansiedad',
            desc: 'El ciclo se repite'
          }].map((step, i) => <Fragment key={i} data-id="element-99">
                <div className="text-center p-4 rounded-xl bg-brand-bg" data-id="element-100">
                  <h3 className="font-bold text-brand-text mb-1" data-id="element-101">
                    {step.title}
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-102">{step.desc}</p>
                </div>
                {i < 3 && <div className="hidden md:flex justify-center text-brand-primary/40" data-id="element-103">
                    <ArrowRight className="w-6 h-6" data-id="element-104" />
                  </div>}
                {i < 3 && <div className="md:hidden flex justify-center text-brand-primary/40 py-2" data-id="element-105">
                    <ArrowRight className="w-6 h-6 rotate-90" data-id="element-106" />
                  </div>}
              </Fragment>)}
          </div>

          <div className="mt-8 text-center border-t border-gray-100 pt-6" data-id="element-107">
            <p className="text-xl font-serif italic text-gray-700" data-id="element-108">
              "No es falta de carácter. Es un sistema sin ajuste."
            </p>
          </div>
        </div>
      </div>
    </Section>;
}